import { KeyboardArrowDown } from '@mui/icons-material';
import {
  AccordionDetails,
  AccordionSummary,
  Accordion as MuiAccordion,
  Typography
} from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  title: string | React.ReactNode;
  backgroundColor?: string;
}>;

export const Accordion: React.FC<Props> = ({
  title,
  children,
  backgroundColor
}) => {
  return (
    <MuiAccordion disableGutters>
      <AccordionSummary
        expandIcon={<KeyboardArrowDown />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          backgroundColor
        }}
      >
        {title && typeof title === 'string' ? (
          <Typography>{title}</Typography>
        ) : (
          title
        )}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor
        }}
      >
        {children}
      </AccordionDetails>
    </MuiAccordion>
  );
};
